import { gql } from '@apollo/client/core';

export interface UpdateOrganizationSettingInput {
  organization: string;
  contentRepositorySettings: string[];
}
export interface UpdateOrganizationSettingResponse {
  updateSettings: {
    contentRepositorySettings: string[];
  };
}

export const UPDATE_ORGANISATION_SETTINGS = gql`
  mutation updateSettings($schema: AllSettingsUpdateSchemaInput!) {
    updateSettings(schema: $schema) {
      contentRepositorySettings
    }
  }
`;
